import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.grayLight};
`;

export const Header = styled.div<{
  headerWithBreadcrumbs?: boolean;
  withStep?: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${({ headerWithBreadcrumbs }) =>
    headerWithBreadcrumbs ? '0 1.5rem 1.5rem 1.5rem' : '1.5rem'};
  padding-bottom: ${({ withStep }) => (withStep ? '0' : '2rem')};
  & > .hefesto-title h1 {
    color: ${({ theme }) => theme.colors.grayDark3};
    margin-bottom: ${({ headerWithBreadcrumbs }) =>
      headerWithBreadcrumbs ? '0' : '1rem'};
  }
  & > .subtitle {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark2};
  }

  .hefesto-step-by-step__content {
    margin: 0;
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 1.5rem;
  .hefesto-step-by-step__content .hefesto-step-by-step__step--finished {
    display: flex;
    align-items: center;
    position: relative;
    .hefesto-icon.Check {
      top: 40%;
      left: 1rem;
      width: fit-content;
    }
  }
`;

export const HeaderActionContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;
